export const createSuccessMessage = (key: string): string =>
  `${key}のお申込みを受け付けました。`;

export const updateSuccessMessage = (key: string): string =>
  `${key}を変更しました。`;

export const createMessage = (key: string): string => `${key}しました。`;
